export interface IWarehouseAdminProductSupplierData {
    id: number;
    product_id?: number;
    supplier_id: number|null;
    supplier_name: string|null;
    legacy_supplier_id: number|null;
    legacy_supplier_name: string|null;
    price: number;
    removed: boolean;
}

export default class WarehouseAdminProductSupplierData {
    public id: number;
    public product_id: number|null;
    public supplier_id: number|null;
    public supplier_name: string|null;
    public legacy_supplier_id: number|null;
    public legacy_supplier_name: string|null;
    public price: number;
    public removed: boolean;

    constructor(data: IWarehouseAdminProductSupplierData) {
        this.id = Number(data.id);
        this.product_id = data.product_id === undefined
            ? null
            : Number(data.product_id);
        this.supplier_id = data.supplier_id === null
            ? null
            : Number(data.supplier_id);
        this.supplier_name = data.supplier_name ?? null;
        this.legacy_supplier_id = data.legacy_supplier_id === null
            ? null
            : Number(data.legacy_supplier_id);
        this.legacy_supplier_name = data.legacy_supplier_name ?? null;
        this.price = Number(data.price);
        this.removed = Boolean(data.removed);
    }
}